
//TODO : 
// date format
// refresh

import React from 'react';
//import Moment from 'react-moment';
import { CardSmall } from '../../widgets/Cards';
//import Modal from '../../widgets/Modal';
//import Confirm from '../../widgets/Confirm';
import {connect} from 'react-redux';
//import { Form, Field} from 'react-final-form';

import { fetchFamilyHistories, fetchFamilyHistory, editFamilyHistory, newFamilyHistory, deleteFamilyHistory} from '../../../actions';

class FamilyHistory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showDelete : false,
            newForm : true,
            record : null,
        };
    };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchFamilyHistories(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchFamilyHistories(this.props.patient._id)
        }   
    }
 
    renderFamilyHistoryList() {

        return this.props.familyhistories.map(familyhistory =>  {
         
          
                return (
                        <tr key={familyhistory._id}>
                            <td>{familyhistory.relation}</td>
                            <td>{familyhistory.condition}</td>
                            <td>{familyhistory.code}</td>
                            <td>{familyhistory.comment}</td>
                        </tr>
                        )
        })
    }

    render() {
        return (
            <CardSmall title='Family History' >
                <table>
                    <thead>
                        <tr>
                            <th>Relation</th>
                            <th>Condition</th>
                            <th>Code</th>
                            <th>Comment</th>
                        </tr>
                    </thead>
                    <tbody> 
                        {this.renderFamilyHistoryList()}
                    </tbody> 
                </table>
            </CardSmall>
        )
    }

}

const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        familyhistories : Object.values(state.familyhistories),
        userId : state.auth.userId,
        selectedFamilyHistory : state.selectedFamilyHistory
    }
}

export default connect(mapStateToProps, {fetchFamilyHistories, fetchFamilyHistory, editFamilyHistory, newFamilyHistory, deleteFamilyHistory})(FamilyHistory);










    








